import Vue from 'vue'
import Hotjar from 'vue-hotjar'

export default ({ app, env }, inject) => {
  Vue.use(Hotjar, {
    id: env.hotjarSiteId,
    isProduction: true
  })
}
